import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, ImageIcon } from 'lucide-react';
import styles from './PortfolioModalGallery.module.scss';

interface PortfolioModalGalleryProps {
  images: Array<{ image: string }>;
  name: string;
  type?: 'producto' | 'servicio';
}

const PortfolioModalGallery: React.FC<PortfolioModalGalleryProps> = ({
  images,
  name,
  type
}) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const hasImages = images && images.length > 0;

  const nextImage = () => {
    if (hasImages && images.length > 1) {
      setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
    }
  };

  const prevImage = () => {
    if (hasImages && images.length > 1) {
      setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
    }
  };

  const imageUrl = encodeURI(images[currentImageIndex]?.image);

  return (
    <div className={styles.gallery_section}>
      {hasImages ? (
        <div className={styles.gallery}>
          <div
            className={styles.gallery_main}
            style={{
              '--bg-image': imageUrl ? `url(${imageUrl})` : 'none'
            } as React.CSSProperties}
          >
            <img
              src={images[currentImageIndex]?.image || '/placeholder.svg'}
              alt={name}
              className={styles.gallery_image}
            />
            {images.length > 1 && (
              <>
                <button className={styles.gallery_nav_prev} onClick={prevImage}>
                  <ChevronLeft size={24} />
                </button>
                <button className={styles.gallery_nav_next} onClick={nextImage}>
                  <ChevronRight size={24} />
                </button>
              </>
            )}
          </div>
          {images.length > 1 && (
            <div className={styles.gallery_thumbnails}>
              {images.map((img, index) => (
                <img
                  key={index}
                  src={img.image || '/placeholder.svg'}
                  alt={`${name} ${index + 1}`}
                  className={`${styles.gallery_thumbnail} ${index === currentImageIndex ? styles.active : ''}`}
                  onClick={() => setCurrentImageIndex(index)}
                />
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className={styles.gallery_mock}>
          <div className={styles.gallery_mock_container}>
            <div className={styles.gallery_mock_icon}>
              <ImageIcon size={64} />
            </div>
            <div className={styles.gallery_mock_text}>
              <span>{type === 'producto' ? 'Producto' : 'Servicio'}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PortfolioModalGallery;

